"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clock_1 = require("@almservices-cl/clock");
const ChatInterface_1 = require("../../BusinessLogicLayer/ChatInterface");
const exception_1 = require("@almservices-cl/exception");
class Chat {
    constructor(dateTimeProvider, identityService, chatRepository) {
        this.i = 0;
        this.after = async (messageId, withMemberId) => {
            const userId = await this.identityService.getId();
            let messages = [];
            if (withMemberId) {
                messages = await this.chatRepository.getMessages(userId, withMemberId);
            }
            let found = messageId === null;
            let outgoingMessages = messages.filter((m) => {
                if (found) {
                    return true;
                }
                if (m.message.id === messageId) {
                    found = true;
                    return false;
                }
                return false;
            });
            if (messageId === null) {
                outgoingMessages = outgoingMessages.slice(outgoingMessages.length - 10);
            }
            return outgoingMessages;
        };
        this.before = async (limit, messageId, withMemberId) => {
            const userId = await this.identityService.getId();
            let messages = [];
            if (withMemberId) {
                messages = await this.chatRepository.getMessages(userId, withMemberId);
            }
            const index = messages.indexOf(messages.find((m) => m.message.id === messageId));
            if (index === -1) {
                throw new exception_1.OutOfRangeException(`Message of id ${messageId} was not found!`);
            }
            if (index < limit) {
                return messages.slice(0, index);
            }
            const startIndex = index - limit;
            return messages.slice(startIndex, startIndex + limit);
        };
        this.doSend = async (message, withMemberId) => {
            const userId = await this.identityService.getId();
            const authorDisplayName = await this.identityService.getDisplayName();
            let messages = [];
            if (withMemberId) {
                messages = await this.chatRepository.getMessages(userId, withMemberId);
            }
            const timeZone = clock_1.UTCTimeZone.z();
            const currentRaw = this.dateTimeProvider.currentRaw(timeZone).date;
            const messageId = (this.i++).toString();
            messages.push({
                authorId: userId,
                authorDisplayName,
                level: null,
                message: {
                    isoDateTime: currentRaw,
                    messageParts: [
                        {
                            name: ChatInterface_1.MessagePartType.TEXT,
                            text: message,
                        },
                    ],
                    id: messageId,
                },
            });
            if (withMemberId) {
                await this.chatRepository.setMessages(userId, withMemberId, messages);
            }
            return messageId;
        };
        this.dateTimeProvider = dateTimeProvider;
        this.identityService = identityService;
        this.chatRepository = chatRepository;
    }
    send(message, withMemberId) {
        return this.doSend(message, withMemberId);
    }
    sendAttachment(_attachment) {
        return Promise.resolve({
            attachment: null,
            id: "mediaId",
        });
    }
}
exports.default = Chat;
//# sourceMappingURL=Chat.js.map